// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const CopyAndMoveTaskDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-copyandmovetaskdialogcontainer" */ "./CopyAndMoveTaskDialogContainer")).then((bundle)=>{
        return {
            default: bundle.CopyAndMoveTaskDialogContainer
        };
    });
export const LazyCopyAndMoveTaskDialogContainer = /*#__PURE__*/ lazy(CopyAndMoveTaskDialogContainerLazyLoader);
